import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css"; // Include TailwindCSS styles
import App from "./App";
import './utility.css'; // Import our utility CSS fixes

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
